export default {
  COMPLETED: 'Completed',
  ACTIVE: 'Active',
  WARNING: 'Warning',
  DEFAULT: 'Default',
  ERROR: 'Error',
}
